import { Injectable, Inject, Output, EventEmitter} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject} from 'rxjs/Subject';
import { Http, Response} from '@angular/http';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import {ActivatedRoute, Router} from '@angular/router';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Singleton Service class to provide Content/Article structure
 **/
@Injectable()
export class ArticleService {
  @Output() menuClick = new EventEmitter();
  articles: any[];
  archives: any[];
  articleUpdated = new EventEmitter();

  constructor(private http: Http, @Inject(APP_CONFIG) private config: AppConfig, route: ActivatedRoute, private router: Router) { }

  getArticle(){
        return this.article;
    }

  getArchive(){
        return this.archives;
    }

   public article = {
        name: 'hello'
    };

    public loading = {
      name: false
    }

    public leContent = "";

    public archive = {};

    private articleUrl: string = this.config.urlArticle;
}



// WEBPACK FOOTER //
// ./src/app/article/article.service.ts